import { SubscriptionType } from '@repo/graphql-types'
import { isStudioAiPricingPlan } from '../../studio-ai-plans'
import { isStudioUnlimitedSubscriptionType, isTeamSubscriptionType } from '../../subscription-types'
import type { PaymentSubscriptionType } from '../../subscription-types'

export type SubscriptionVariant =
  | 'all_access'
  | 'ai_studio'
  | 'studio_unlimited'
  | 'coin_pack'
  | 'team'

export const COIN_PACK_SUBSCRIPTION_TYPES = new Set<PaymentSubscriptionType>([
  SubscriptionType.CoinPackMonthly25k,
  SubscriptionType.CoinPackMonthly100k,
  SubscriptionType.CoinPackMonthly250k,
  SubscriptionType.CoinPackMonthly400k,
  SubscriptionType.CoinPackMonthly700k,
  SubscriptionType.CoinPackMonthly1M,
])

export function isCoinPackSubscriptionType(subscriptionType: PaymentSubscriptionType | undefined) {
  return Boolean(subscriptionType && COIN_PACK_SUBSCRIPTION_TYPES.has(subscriptionType))
}

export function isAiStudioSubscriptionType(subscriptionType: PaymentSubscriptionType | undefined) {
  return (
    isStudioAiPricingPlan(subscriptionType) ||
    subscriptionType === SubscriptionType.StudioAiYearlyFreeTrial ||
    subscriptionType === SubscriptionType.StudioAiYearly
  )
}

export function isAllAccessFreeTrialSubscriptionType(
  subscriptionType: PaymentSubscriptionType | undefined,
) {
  return (
    subscriptionType === SubscriptionType.AllAccessMonthlyFreeTrial ||
    subscriptionType === SubscriptionType.AllAccessYearlyFreeTrial
  )
}

export function isFreeTrialSubscriptionType(subscriptionType: PaymentSubscriptionType | undefined) {
  return (
    isAllAccessFreeTrialSubscriptionType(subscriptionType) ||
    subscriptionType === SubscriptionType.StudioAiYearlyFreeTrial
  )
}

export function getSubscriptionVariant(
  subscriptionType: PaymentSubscriptionType | undefined,
): SubscriptionVariant {
  if (!subscriptionType) {
    return 'all_access'
  }

  if (isAiStudioSubscriptionType(subscriptionType)) {
    return 'ai_studio'
  }

  if (isCoinPackSubscriptionType(subscriptionType)) {
    return 'coin_pack'
  }

  if (isTeamSubscriptionType(subscriptionType)) {
    return 'team'
  }

  if (isStudioUnlimitedSubscriptionType(subscriptionType)) {
    return 'studio_unlimited'
  }

  return 'all_access'
}
